import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './sail.css';
import { sail_item } from '../../json/sail';
import { acciones_sail } from '../../json/acciones_sail';

const Sail = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    


    <div className='container'>
            <div className='row'>
              <div className='secretaria_logo' >
                <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Trabajo.svg")` }}>
    
                </div>
              </div>
              <div className='secretaria_name'>
                <h1>Sistema Alterno de Inspección Laboral</h1>
              </div>

            <div className='secretaria_name'>
                <hr className='hr-gob'/>
                    El Sistema Alterno de Inspección Laboral es un mecanismo que ayuda a los centros de trabajo a dar cumplimiento a las obligaciones patronales que la Ley Federal del Trabajo establece, a través de un diagnóstico sencillo, transparente, amigable y gratuito, en el cual les dará conocer la situación en la que se encuentran y cuyo resultado se traduce en un esquema que les permita regularizarse a través del acompañamiento de asesoría en su cumplimiento a la normativa laboral.
            </div>


              <div className='secretaria_funciones'>
                <div style={{ marginTop: '20px'}}></div>
                <hr className='hr-gob'/>
                 
                <div style={{ marginTop: '-50px'}}></div>
                <div className='row'>
                  {
                    
                    acciones_sail.map((item, index)=>(
                        <div key={ index } className='col-md-6 col-sm-6 col-12'>
                            <div className='card_container_acciones'>
                                <div className='card_cero'>
                                    <h5>{ item.anio }</h5>
                                    <h6>{ item.descripcion }</h6>
                                    {
                                        item.trimestres.map((trim, index)=>(
                                            <div key={ index } className='card_trimestre'>
                                                <p>{ trim.trimestre } <span className="badge bg-secondary">
                                                    <a href={ trim.url } target="_blank">Ver</a></span>
                                                </p> 
                                            </div>
                                    ))
                                    }
                                </div>
                            </div>
                        </div>
                        ))
                    }
    
                  </div>
                  
              </div>
            </div>
    <div style={{ marginTop: '-20px'}}></div>
            <div className='secretaria_funciones'>
                
                <hr className='hr-gob'/>
                
                  <img  className="imagen-mision" src={"./assets/imgs/sail/sail_uno.jpg"}/>
          </div>
            <div className='secretaria_funciones'>
                
                <hr className='hr-gob'/>
                
                  <img  className="imagen-mision" src={"./assets/imgs/sail/sail_dos.jpg"}/>
          </div>
          <div className='secretaria_funciones'>
                
                <hr className='hr-gob'/>
                
                  <img  className="imagen-mision" src={"./assets/imgs/sail/sail_tres.jpg"}/>
          </div>
          <div className='secretaria_funciones'>
                
                <hr className='hr-gob'/>
                
                  <img  className="imagen-mision" src={"./assets/imgs/sail/sail_cuatro.jpg"}/>
          </div>
          <div className='secretaria_funciones'>
                
                <hr className='hr-gob'/>
                
                  <img  className="imagen-mision" src={"./assets/imgs/sail/sail_cinco.jpg"}/>
          </div>

<div style={{ marginTop: '20px'}}></div>
    </div>
    
  )

}   
export default Sail